import { gql } from '@apollo/client';

export const CYCLE_COUNT_LOCATION_BY_PK = gql`
    query CycleCountLocationByPk($cycle_count_location_id: uuid!) {
        cycle_count_locations_by_pk(cycle_count_location_id: $cycle_count_location_id) {
            cycle_count_location_id
            cycle_count_id
            warehouse_location
            audited_at
            cycle_count {
                cycle_count_id
                warehouse_id
                warehouse {
                    location_id
                    location_name
                }
            }
            scans {
                scan_id
                pallet_item_id
                expected_warehouse_location
                scanned_at
                pallet_item {
                    pallet_id
                    warehouse_location
                    items {
                        item_id
                        sku
                        description
                        order {
                            order_id
                            po_number
                        }
                    }
                }
            }
        }
    }
`;

export const CYCLE_COUNT_LOCATION_EXPECTED_ITEMS = gql`
    query CycleCountLocationExpectedItems(
        $warehouse_id: uuid!
        $warehouse_location: String!
    ) {
        items(
            where: {
                pallet: {
                    warehouse_id: { _eq: $warehouse_id }
                    warehouse_location: { _eq: $warehouse_location }
                }
            }
        ) {
            item_id
            pallet_id
            sku
            description
            order {
                order_id
                po_number
            }
        }
    }
`;
